const settingApiKeysCNSimplify = {
  settings_api_keys_api_docs: "更多信息 - API",
  settings_apikeys_create_dialog_title: "创建新的 API 密钥",
  settings_apikeys_create_dialog_desc:
    "创建一个新的 API 密钥以便外部系统访问您的账户。",
  settings_apikeys_form_name_placeholder: "输入 API 密钥名称",
  settings_apikeys_form_description_placeholder: "输入密钥用途的简短描述",
  settings_apikeys_form_services_placeholder: "选择与此密钥关联的服务",
  settings_api_keys_api_tip:
    "如果您没有为此新密钥选择任何 API，我们将假设此新密钥为‘主密钥’",
  settings_api_keys_api_set_master_key: "设置为主密钥",
  "API Keys": "API 密钥",
  API_Service: "服务",
  usage_total_this_month: "本月总调用次数：",
  usage_remaining_quota: "剩余配额：",
  usage_reset_on: "重置于：",
  call: "次调用 | 次调用 | 次调用",
  _usage_sub_title: "使用量",
  portal_usage_sub_title: "查询上限",
  hourly: "每小时",
  daily: "每日",
  monthly: "每月",
  usage_portal_title: "平台使用限额",
  usage_api_title: "API",
  settings_apikeys_name: "API 密钥名称",

  api_keys_column_query_type: "查询类型",
  api_keys_column_auth_type: "认证类型",
  api_keys_column_credential: "凭证",
  settings_api_logs_column_method: "方法",
  settings_api_logs_column_endpoint: "端点",
  settings_api_logs_column_status: "状态",
  settings_api_logs_column_duration: "耗时",
  settings_api_logs_detail_request: "请求",
  settings_api_logs_detail_response: "响应",
  settings_api_logs_detail_request_id: "请求 ID",
  settings_api_keys_click_here_more_info: "点击此处了解更多信息",
  settings_api_keys_title: "API 密钥",
  settings_api_keys_desc:
    "API 密钥设置页面支持安全地创建、编辑和限制 API 密钥。用户可以分配名称、设置使用限制并管理权限，从而有效控制访问。",
  settings_api_keys_generated_by: "创建者",
  api_key: "API 密钥",
  logs: "日志",

  new_api_key: "新建 API 密钥",
  dashboard: "仪表盘",
  settings_api_dashboard_empty_title: "暂无 API 活动",
  settings_api_dashboard_empty_desc:
    "当您的集成开始进行调用后，此仪表盘将显示每日积分消耗、请求数量以及按密钥和端点的明细。",
  settings_api_dashboard_empty_cta: "查看快速入门",
  settings_api_dashboard_chart_title: "每日使用情况",
  settings_api_dashboard_chart_metric_credits: "积分",
  settings_api_dashboard_chart_metric_calls: "调用次数",
  settings_api_dashboard_chart_no_data: "此区间内无使用记录",
  settings_api_dashboard_chart_others: "其他",
  settings_api_dashboard_chart_last_refreshed: "最近更新 {time}",
  settings_api_dashboard_kpi_total_credits: "总积分",
  settings_api_dashboard_kpi_credits_pending: "等待后端支持",
  settings_api_dashboard_kpi_total_calls: "总调用次数",
  settings_api_dashboard_kpi_avg_per_day: "日均",
  settings_api_dashboard_kpi_avg_per_day_short: "日",
  settings_api_dashboard_kpi_range_days: "最近 {days} 天",
  settings_api_dashboard_kpi_top_endpoint: "最常用端点",
  settings_api_dashboard_kpi_top_key: "最常用 API 密钥",
  settings_api_dashboard_filter_date_label: "日期范围",
  settings_api_dashboard_filter_keys_label: "API 密钥",
  settings_api_dashboard_filter_keys_placeholder: "所有 API 密钥",
  settings_api_dashboard_filter_log_types_label: "日志类型",
  settings_api_dashboard_filter_log_types_placeholder: "所有日志类型",
  settings_api_dashboard_preset_7d: "最近 7 天",
  settings_api_dashboard_preset_30d: "最近 30 天",
  settings_api_dashboard_preset_90d: "最近 90 天",
  settings_api_dashboard_preset_custom: "自定义",
  settings_api_dashboard_table_by_key: "按 API 密钥",
  settings_api_dashboard_table_by_endpoint: "按查询类型",
  settings_api_dashboard_table_col_name: "名称",
  settings_api_dashboard_table_col_endpoint: "查询类型",
  settings_api_dashboard_table_col_calls: "调用次数",
  settings_api_dashboard_table_col_credits: "积分",
  settings_api_dashboard_table_col_cost_per_call: "每次调用消耗",
  settings_api_dashboard_table_col_percent: "占比",
  settings_api_dashboard_table_empty: "此区间内无调用",
  settings_api_dashboard_truncated_banner:
    "仅显示该区间内最近 5,000 条请求。缩小日期范围以查看完整数据。",
  settings_api_dashboard_provisional_note:
    "后端仪表盘端点尚未部署 —— 当前数据通过 /api_keys/logs 聚合得出。/api_keys/usage/daily 上线后将显示积分消耗。",

  log_type_label_people_search: "用户检索",
  log_type_label_people_select_search: "用户选择检索",
  log_type_label_people_search_preview: "用户检索预览",
  log_type_label_people_similar_search: "相似用户检索",
  log_type_label_people_similar_search_preview: "相似用户检索预览",
  log_type_label_people_details: "用户详情",
  log_type_label_people_redeem: "兑换用户资讯",
  log_type_label_people_email_redeem: "兑换邮箱",
  log_type_label_people_phone_redeem: "兑换电话",
  log_type_label_people_lookup_reveal: "用户查找揭示",
  log_type_label_people_contact_lookup: "用户联系方式查找",
  log_type_label_people_enrichment: "用户信息增强",
  log_type_label_people_export: "用户导出",
  log_type_label_people_linkedin_lookup: "用户 LinkedIn 查找",
  log_type_label_email_validation: "邮箱验证",
  log_type_label_company_search: "公司检索",
  log_type_label_company_select_search: "公司选择检索",
  log_type_label_company_search_preview: "公司检索预览",
  log_type_label_company_similar_search: "相似公司检索",
  log_type_label_company_similar_search_preview: "相似公司检索预览",
  log_type_label_company_trending_search: "公司趋势检索",
  log_type_label_company_details: "公司详情",
  log_type_label_company_news: "公司新闻检索",
  log_type_label_company_jobs: "公司职位检索",
  log_type_label_company_enrichment: "公司信息增强",
  log_type_label_company_export: "公司导出",
  log_type_label_company_linkedin_lookup: "公司 LinkedIn 查找",
  log_type_label_company_technology_lookup: "公司技术栈查找",
  log_type_label_company_lookup_similar: "公司相似查找",
  log_type_label_news_search: "新闻检索",
  log_type_label_news_search_preview: "新闻检索预览",
  log_type_label_job_search: "职位检索",
  log_type_label_job_search_preview: "职位检索预览",
  log_type_label_advertisement_lookup: "广告查找",
  log_type_label_advertisement_search: "广告检索",
  log_type_label_advertisement_search_preview: "广告检索预览",
  log_type_label_ai_translation: "AI 翻译",
  log_type_label_monitor_trigger: "监控触发",
  log_type_label_general: "通用",
};

export default settingApiKeysCNSimplify;
